import { requests } from '../../helper/agent';
import * as API_ROUTES from '../../routing/api';
import { userLogout } from './user';
import { SubmissionError } from 'redux-form';
import { parseApiErrors } from '../../helper/apiUtils';
import { INVOICE_ESCALATION_REASON_LIST_ERROR, INVOICE_ESCALATION_REASON_LIST_RECEIVED, INVOICE_ESCALATION_REASON_LIST_REQUEST } from '../constants';

export const invoiceEscalationReasonRequest = () => ({
  type: INVOICE_ESCALATION_REASON_LIST_REQUEST,
});

export const invoiceEscalationReasonReceived = (data) => ({
  type: INVOICE_ESCALATION_REASON_LIST_RECEIVED,
  data,
});

export const invoiceEscalationReasonError = (error) => ({
  type: INVOICE_ESCALATION_REASON_LIST_ERROR,
  error,
});

export const invoiceEscalationReasonFetch = () => {
  return (dispatch) => {
    dispatch(invoiceEscalationReasonRequest());
    const filters = { pagination: false };
    return requests
      .get(API_ROUTES.INVOICE_ESCALATION_REASON, filters)
      .then((response) => dispatch(invoiceEscalationReasonReceived(response)))
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return dispatch(userLogout());
        } else if (error.response && error.response.status === 403) {
          return new SubmissionError(parseApiErrors({ _error: 'You are not allowed to do this.' }));
        }
        dispatch(invoiceEscalationReasonError(error));
      });
  };
};
